import { render, staticRenderFns } from "./CourseSchedulesListComponent.vue?vue&type=template&id=465aef12"
import script from "./CourseSchedulesListComponent.vue?vue&type=script&lang=js"
export * from "./CourseSchedulesListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports